import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { OnlineCodeEditor } from "@/components/OnlineCodeEditor/index";
import { isEmpty, isNotEmpty, Base64 } from "@/libs/tools";
import { Mutation, State } from "vuex-class";
import VueScroll from "vuescroll";
import SplitPanel from "@/components/SplitPanel";
import { postUserAnswer, getCodeShare } from "@/api/course";
// import { CodeShare } from "../CodeShare";
import { AiShare } from "@/pages/aijiaoai/components/AiShare/index";
import { CodeHelp } from "@/pages/aijiaoai/components/CodeHelp/index";
import { getNextItem } from "@/api/aijiaoaiCourse";
import { RestTips } from "./components/ResetTips";
import { RunStatus } from "./components/RunStatus";
import { OutputHead } from "./components/OutputHead";
import { appName } from "../../../../../config/url";

@Component({
    components: {
        OnlineCodeEditor,
        VueScroll,
        SplitPanel,
        // CodeShare, // 分享
        AiShare, // 求助或分享
        CodeHelp, // 提示按钮=》思路和分享
        RestTips,
        RunStatus,
        OutputHead
    }
})
export default class CodeEditor extends Vue {
    @Prop() readonly item!: any;
    @Prop() readonly section!: any;
    @Mutation("study/changeCodeFullscreenVar")
    mutationChangeCodeFullscreenVar: any;
    @State("study") studyState: object;
    @Mutation("study/changeMenuVariable") changeMenuVariableFlag:
        | boolean
        | undefined;
    private ops: any = {
        vuescroll: {
            mode: "native"
        },
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(255, 255, 255, .4)"
        }
    };
    private shareVariable: boolean = false;
    private answerVariable: boolean = false;
    private codeOps = {
        codeRef: "codeArea" + this.item.id,
        outputAreaRef: "outputArea" + this.item.id,
        kernelOptions: {
            path: ""
        }
    };
    private offsetVerticalRight: string = "270px";
    private offset: number = 0.5;
    private userAnswerParams = {
        courseId: 0,
        sectionId: 0,
        logicId: 0,
        id: 0,
        userAnswer: ""
    };
    private shareData: any = {};
    private answerData: any = {};
    private dataParams: any = {};
    private scrollTop: number | undefined;
    private fullscreen: boolean = false;
    private showRedo: boolean = false;
    private isDisable: boolean = false;
    private showErrorHelp: boolean = false; //运行失败 分享求助
    private showSuccessShare: boolean = false; //运行成功 分享结果
    private isRunning: boolean = false; //是否是loding运行状态
    private isSuccessEmpty: boolean = false; //是否有运行结果
    get codeRunStatus() {
        return this.$store.state.aistudy.codeRunStatus;
    }
    @Watch("codeRunStatus")
    getCodeRunStatus(newVal: string) {
        this.$store.state.aistudy.codeRunStatus = newVal;
    }
    mounted() {
        let user = JSON.parse(localStorage.getItem("user"));
        this.userAnswerParams.courseId = this.item.courseId;
        this.userAnswerParams.sectionId = this.item.sectionId;
        this.userAnswerParams.logicId = this.item.logicId;
        this.userAnswerParams.id = this.item.id;
        // this.codeOps.kernelOptions.path =
        //     "/" + this.item.pageType + "/" + this.item.id + ".ipynb";
        this.codeOps.kernelOptions.path =
            "/" + appName + "/" + user.userId + ".ipynb";
        this.$nextTick(() => {
            this.renderData();
            this.$refs["editor" + this.item.id]
                //@ts-ignore
                .getCodeMirror()
                .on("blur", () => {
                    let code = this.$refs["editor" + this.item.id]
                        //@ts-ignore
                        .getCodeMirror()
                        .getValue();
                    let codeResult = document.querySelector(
                        "#outputArea" + this.item.id + " .jp-OutputArea"
                    ).innerHTML;
                    this.codeSubmit(code, codeResult);
                });
        });
    }

    renderData() {
        // 渲染左侧code代码
        if (isEmpty(this.item.userAnswer)) {
            if (isNotEmpty(this.item.page.code)) {
                this.$refs["editor" + this.item.id]
                    //@ts-ignore
                    .getCodeMirror()
                    .setValue(this.item.page.code);
            }
        } else {
            this.$refs["editor" + this.item.id]
                //@ts-ignore
                .getCodeMirror()
                .setValue(this.item.userAnswer);
        }
        // 用户输出结果不为空则展示用户输出结果
        // 注意无输出不代表没运行
        if (isNotEmpty(this.item.answerResult)) {
            document.querySelector(
                "#outputArea" + this.item.id + " .jp-OutputArea"
            ).innerHTML = this.item.answerResult;
        }
        // 若有isRight值则表明运行过渲染用户运行的结果
        if (this.item.isRight) {
            switch (this.item.isRight) {
                case "YES":
                    this.checkRunStatus(false, true, false, false);
                    break;
                case "NO":
                    this.checkRunStatus(true, false, false, false);
                    break;
                case "UNKNOWN":
                    this.checkRunStatus(false, true, false, true);
                    break;
            }
        }
    }

    runCode() {
        document.querySelector(
            "#outputArea" + this.item.id + " .jp-OutputArea"
        ).innerHTML = "";
        this.$store.commit("aistudy/changeCodeRunStatus", "notRun");
        //每次重新运行代码时清空右侧输出内容和弹框
        this.checkRunStatus(false, false, false, false);
        let code = this.$refs["editor" + this.item.id]
            //@ts-ignore
            .getCodeMirror()
            .getValue();
        if (isEmpty(code)) {
            this.$message.warning("同学，你好像忘记写代码了^_^");
        } else {
            //@ts-ignore
            this.$refs["editor" + this.item.id].execute(code);
            /**
             * 设置计时器去监测execute()方法执行后返回的状态
             * notRun 表示运行中，未返回结果
             * error 表示运行失败
             * ok 表示运行成功
             */
            let timer = setInterval(() => {
                if (this.codeRunStatus === "notRun") {
                    this.checkRunStatus(false, false, true, false);
                } else if (this.codeRunStatus === "ok") {
                    let resultLength = document.querySelector(
                        "#outputArea" + this.item.id + " .jp-OutputArea"
                    ).childElementCount;
                    this.checkRunStatus(false, true, false, resultLength <= 0);
                    this.$set(this.item, "isCoding", false);
                    clearInterval(timer);
                    this.$store.commit("aistudy/changeCodeRunStatus", "notRun");
                    let codeResult = document.querySelector(
                        "#outputArea" + this.item.id + " .jp-OutputArea"
                    ).innerHTML;
                    // TODO 连续调用2次submit,异步执行顺序无法判断
                    // 失去焦点会先调用submit，运行接着调用submit
                    setTimeout(() => {
                        let isRight = resultLength > 0 ? "YES" : "UNKNOWN";
                        this.codeSubmit(code, codeResult, isRight);
                    }, 1600);
                } else if (this.codeRunStatus === "error") {
                    this.checkRunStatus(true, false, false, false);
                    clearInterval(timer);
                    this.$store.commit("aistudy/changeCodeRunStatus", "notRun");
                    let codeResult = document.querySelector(
                        "#outputArea" + this.item.id + " .jp-OutputArea"
                    ).innerHTML;
                    setTimeout(() => {
                        this.codeSubmit(code, codeResult, "NO");
                    }, 1600);
                }
            }, 100);
        }
    }
    // 代码运行状态提醒
    checkRunStatus(
        isFail: boolean,
        isSuccess: boolean,
        isLoad: boolean,
        isSuccessEmpty: boolean
    ) {
        this.isSuccessEmpty = isSuccessEmpty;
        this.showSuccessShare = isSuccess;
        this.showErrorHelp = isFail;
        this.isRunning = isLoad;
    }

    // 保存用户代码
    codeSubmit(code: string, codeResult: string, isRight?: string) {
        let params = {
            courseId: this.item.courseId,
            sectionId: this.item.sectionId,
            logicId: this.item.logicId,
            id: this.item.id,
            userAnswer: code,
            answerResult: codeResult,
            isRight: isRight,
            update: true
        };
        getNextItem(params).then(res => {
            //@ts-ignore
            if (res.code === 200) {
                // eslint-disable-next-line
                // console.log("代码保存失败");
            }
        });
    }
    // 显示重做
    handleShowRedo() {
        this.showRedo = true;
    }
    // 不重做
    handleCancleClick() {
        this.showRedo = false;
    }
    // 确认重做
    handleConfirmClick() {
        if (isNotEmpty(this.item.page.code)) {
            this.$refs["editor" + this.item.id]
                //@ts-ignore
                .getCodeMirror()
                .setValue(this.item.page.code);
        } else {
            this.$refs["editor" + this.item.id]
                //@ts-ignore
                .getCodeMirror()
                .setValue("");
        }
        //@ts-ignore
        this.$refs["editor" + this.item.id].restart();
        this.checkRunStatus(false, false, false, false);
        this.showRedo = false;
    }

    get menuVariable() {
        return this.$store.state.study.menuVariable;
    }
    // 编辑器全屏
    fullscreenClick() {
        let el = this.$refs["codeFullScreen"];

        this.fullscreen = true;
        let rfs =
            //@ts-ignore
            el.requestFullScreen ||
            //@ts-ignore
            el.webkitRequestFullScreen ||
            //@ts-ignore
            el.mozRequestFullScreen ||
            //@ts-ignore
            el.msRequestFullScreen;

        //typeof rfs != "undefined" && rfs
        if (rfs) {
            rfs.call(el);
            //@ts-ignore
        } else if (typeof window.ActiveXObject !== "undefined") {
            //for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
            let wscript = new ActiveXObject("WScript.Shell");
            if (wscript != null) {
                wscript.SendKeys("{F11}");
            }
        }
    }
    // 退出编辑器全屏
    exitScreen() {
        this.fullscreen = false;
        var el = document;
        var cfs =
            //@ts-ignore
            el.cancelFullScreen ||
            //@ts-ignore
            el.webkitCancelFullScreen ||
            //@ts-ignore
            el.mozCancelFullScreen ||
            //@ts-ignore
            el.exitFullScreen;

        //typeof cfs != "undefined" && cfs
        if (cfs) {
            cfs.call(el);
            //@ts-ignore
        } else if (typeof window.ActiveXObject !== "undefined") {
            //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript != null) {
                wscript.SendKeys("{F11}");
            }
        }
    }

    // 求助或者成功分享设置
    handleShareClick(item, val) {
        if (val === "help") {
            this.dataParams.studyStatus = "遇到了困难";
        } else if (val === "share") {
            this.dataParams.studyStatus = "完成了";
        }
        this.dataParams.titleDes = val;
        this.dataParams.desc = item.page.desc;
        this.dataParams.title = item.page.title;
        this.dataParams.nickname = Base64.decode(
            JSON.parse(<string>localStorage.getItem("user")).nickname
        );
        //@ts-ignore
        this.dataParams.avatar = this.userImg = JSON.parse(
            <string>localStorage.getItem("user")
        ).avatar;
        this.dataParams.code = this.$refs["editor" + this.item.id]
            //@ts-ignore
            .getCodeMirror()
            .getValue()
            .trim();
        this.dataParams.result = this.$refs[
            "outputArea" + this.item.id
            //@ts-ignore
        ].innerHTML;
        this.dataParams.userId = item.userId;
        this.shareData = this.dataParams;
        // @ts-ignore
        getCodeShare(this.dataParams).then(res => {
            //@ts-ignore
            if (res.code === 200) {
                this.dataParams.codeUrl = res.data;
                this.shareVariable = !this.shareVariable;
            }
        });
        // 防止点击频率过快 TODO 抽出公用的方法 节流与防抖
        this.isDisable = true;
        setTimeout(() => {
            this.isDisable = false;
        }, 1000);
    }

    // 关闭求助和分享
    handleClose(v) {
        this.shareVariable = v;
    }
    handleAnswerClose() {
        this.answerVariable = false;
    }

    handleAnswerClick(item) {
        this.answerVariable = true;
        this.answerData = {
            answer: item.page.solution,
            think: item.page.think,
            desc: item.page.desc
        };
    }

    @Emit()
    handleJumpClick() {
        return this.item;
    }
}

//@ts-ignore
export { default as CodeEditor } from "./index.vue";
